module.exports = __webpack_public_path__ + "static/media/lynkit.3606688e.png";